<template>
    <v-app id="form">

        <v-layout row class="px-lg-5">
            <v-form ref="form">  
            <v-flex lg12 xs12> 

                    <v-row class="ml-lg-n4 ml-1 mt-lg-5 mt-2">

                            <v-col cols="1" lg="12" xs="12">

                                <v-row style="width:380px !important;">

                                    <div class="mt-lg-1"> <v-img src="@/assets/images/Monitoring/assignment.svg" /> </div> 

                                        <div class="mt-n1 ml-1"> 


                                             <v-autocomplete
                                                v-model="tutor"
                                                :items="tutors"
                                                item-text="name"
                                                item-value="name2"
                                                dense
                                                label="[tutor_full_name]"
                                                class="ml-lg-1 tutor-field"
                                                @change="FilterDataTable()"
                                                :rules="inputRules"
                                            ></v-autocomplete> 


                                        
                                         </div>
                                   
                                </v-row>

                            </v-col>

                    </v-row>

                
                    <v-layout row class="mt-10 px-2">


                                            <v-flex lg3 xs12>
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/position.svg"  aspect-ratio='1' contain max-width="30"/> </div> 
                                                             <v-autocomplete v-model="position" :items="posArr" :rules="inputRules" dense label="POSITION" class="ml-lg-8 mt-lg-n6 tutor-field"></v-autocomplete>
                                                            

                                                        </v-row>
                                            </v-flex>

                                            <v-flex lg3 xs12 class="ml-lg-16 mt-lg-0 mt-10">
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/location.svg"  aspect-ratio='1' contain max-width="100"/> </div> 
                                                               <v-autocomplete v-model="location" :items="locArr" :rules="inputRules" dense label="LOCATION" class="ml-lg-8 mt-lg-n6 tutor-field"></v-autocomplete>
                                                       
                                                        </v-row>


                                        </v-flex>

                                                    
                                        <v-flex lg3 xs12 class="ml-lg-16 mt-lg-0 mt-10">
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/calendar.svg"  aspect-ratio='1' contain max-width="20"/> </div>  
                                                             <v-row>
                                                                <v-col cols="11" sm="6" md="4" lg="12">
                                                                <v-menu ref="menudate"  v-model="menudate" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition"
                                                                    offset-y offset-lg="2" max-width="290">

                                                                    <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field :rules="inputRules" v-model="date" label="DATE OF INFRACTION" readonly v-bind="attrs" v-on="on" class="input-size mt-n4 ml-2"></v-text-field>
                                                                    </template>
                                                                    <v-date-picker v-model="date" no-title scrollable :max="maxDate">
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn text color="primary" @click="menudate = false">
                                                                        Cancel
                                                                    </v-btn>
                                                                    <v-btn text color="primary" @click="$refs.menudate.save(date)">
                                                                        OK
                                                                    </v-btn>
                                                                    </v-date-picker>
                                                                </v-menu>
                                                                </v-col>
                                                            </v-row>

                                                        </v-row>
                                        </v-flex>
                            </v-layout>

   
                                            

                </v-flex>

                <v-flex lg12 class="mt-10 ml-n2">

                    
                        <div class="barcolor">

                           <div> <span class="ml-lg-5" > Infraction* </span> </div>
                            

                        </div>
                        <div class="textareaBg mt-n1">

                            <v-layout class="pb-5">

                                    <v-flex lg5>

                                         <v-radio-group v-model="actTaken" class="ml-6" :rules="inputRules" @change="chooseActTaken()">

                                             <v-radio value="1"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 1. Unexcused Absence </div> 
                                                </v-row> </label>

                                             <v-radio  value="2" class="mt-2"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 2. Undertime </div> 
                                                </v-row> </label>

                                             <v-radio value="3" class="mt-2"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 3. Tardy </div> 
                                                </v-row> </label>

                                             <v-radio value="4" class="mt-2"></v-radio> <label class="ml-lg-2 chkboxLabel"> 
                                                <v-row class="mt-n7 ml-6"> <div> 4. Missed Class</div> 
                                                </v-row> </label>

                                                
                                         </v-radio-group>

                                    </v-flex>

                                    <v-flex lg6>

                                         <v-layout row class="mt-lg-3">

                                            <v-flex lg12>

                                             <v-autocomplete v-model="dueToUn" :rules="actTaken ==1 ? inputRules : ''" :readonly="actTaken=='1' ? false : true" :items="dueTo" dense label="Due to" class="ml-lg-1 tutor-field"
                                                @change="FilterDataTable()"></v-autocomplete>
                                            
                                            </v-flex>

                                            <v-flex lg12 class="mt-lg-1 ml-lg-2">

                                                <v-layout>

                                                        <v-flex lg2>
                                                        
                                                          <div class="infactor-sub-menu"> Hour/s </div>
                                                         
                                                        </v-flex>

                                                        <v-flex lg2 class="ml-lg-n3">

                                                              <v-text-field type="number" :rules="actTaken ==2 ? inputRules : ''" v-model="UThours" :readonly="actTaken=='2' ? false : true"  v-bind="attrs" v-on="on" class="input-size-other mt-n7 ml-2 styled-input"></v-text-field> 

                                                        </v-flex>

                                                         <v-flex lg8>

                                                            <input type="checkbox" class="chkbox" value="Other" v-model="chkUt" :disabled="actTaken=='2' ? false : true"> <label class="ml-lg-2 chkboxLabel"> 
                                                                    <v-row class="mt-n6 ml-5"> <div class="infactor-sub-menu "> Missed class/es </div>  <v-text-field type="number" :rules="chkUt ==  true ? inputRules : ''" :readonly="chkUt==true ? false : true" v-model="UtMissed" v-bind="attrs" v-on="on" class="input-size-missed mt-n12 ml-16 styled-input"></v-text-field>
                                                                    </v-row> </label>

                                           

                                                        </v-flex>
                                                        

                                                </v-layout>

                                             
                                            
                                            </v-flex>

                                            <v-flex lg12 class="mt-lg-1 ml-lg-2">

                                                <v-layout>

                                                        <v-flex lg2>
                                                        
                                                          <div class="infactor-sub-menu"> Hour/s </div>
                                                         
                                                        </v-flex>

                                                        <v-flex lg2 class="ml-lg-n3">

                                                              <v-text-field type="number" :rules="actTaken ==3 ? inputRules : ''" :readonly="actTaken=='3' ? false : true" v-model="Tarhours"  v-bind="attrs" v-on="on" class="input-size-other mt-n7 ml-2 styled-input"></v-text-field> 

                                                        </v-flex>

                                                         <v-flex lg8>

                                                            <input type="checkbox" class="chkbox" value="Other" v-model="chkTar" :disabled="actTaken=='3' ? false : true"> <label class="ml-lg-2 chkboxLabel"> 
                                                                    <v-row class="mt-n6 ml-5"> <div class="infactor-sub-menu "> Missed class/es </div>  <v-text-field type="number" :rules="chkTar ==  true ? inputRules : ''" :readonly="chkTar==true ? false : true"  v-model="TarMissed" v-bind="attrs" v-on="on" class="input-size-missed mt-n12 ml-16 styled-input"></v-text-field>
                                                                    </v-row> </label>

                                           

                                                        </v-flex>
                                                        

                                                </v-layout>

                                             
                                            
                                            </v-flex>

                                            <v-flex lg12 class="mt-lg-n2">

                                             <v-autocomplete v-model="dueToMissed" :rules="actTaken ==4 ? inputRules : ''" :readonly="actTaken=='4' ? false : true" :items="dueTo" dense label="Due to" class="ml-lg-1 tutor-field"
                                                ></v-autocomplete>
                                            
                                            </v-flex>

                                            <v-flex lg12 class="mt-lg-n4">

                                             <v-text-field type="number" :rules="actTaken ==4 ? inputRules : ''" :readonly="actTaken=='4' ? false : true" v-model="NoMC" label="Number of Missed Classes"  v-bind="attrs" v-on="on" class="ml-1 styled-input"></v-text-field>
                                            
                                            </v-flex>

                                        </v-layout>

                                    </v-flex>

                            </v-layout>

                        </div>  

                </v-flex>

                <v-flex lg12 class=" ml-n2">

                    
                        <div class="barcolor">

                           <div> <span class="ml-lg-5" > Details* </span> </div>
                        

                        </div>
                        <div class="textareaBg mt-n1">

                            <v-layout>
                                <v-flex lg12 class="ml-lg-10">

                                    <v-textarea
                                    v-model="details"
                                    placeholder="Please put as much detail as possible."
                                    class="textarea"
                                    auto-grow
                                    :rules="inputRules"
                                    ></v-textarea>

                                </v-flex>

                            </v-layout>

                        </div>  

                </v-flex>

                <v-flex lg12 class="ml-n2 mt-5">

                    
                        <div class="barcolor2">

                             <v-row class="pt-lg-5 ml-8 ">

                                 <div> Attempt* </div> 
                                 <v-text-field :rules="inputRules" type="number" v-model="NoAttempts" label="Number of attempts"  v-bind="attrs" v-on="on" class="attemp-field mt-n4 ml-2 styled-input"></v-text-field>
                                                       
                            </v-row>

                        </div>

                </v-flex>
                

                 <v-flex lg12 class="mt-lg-7 pb-5">
                                        
                                        <v-layout justify-end>
                                            <v-btn color="rgb(0, 99, 158)" class="white--text" @click="SaveIssue()"> SUBMIT </v-btn>
                                        </v-layout>

                </v-flex>  
            </v-form>
        </v-layout>


        <!-- dialogbox -->


        <v-dialog
                            transition="dialog-bottom-transition"
                            max-width="100%"
                            v-model="dialogshow"
                            persistent
                          >
                            <v-card style="background-color:#000C17 !important">
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false)"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions>
                              <v-card-text>

                                <div
                                  class="text-h3 white--text"
                                >
                                  Data Successfully Saved!
                                </div>
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                <v-btn
                                  text
                                  @click="(dialogshow = false)"
                                >
                                  <span class="white--text"> Close </span>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
        </v-dialog>



    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'managerReviewForm',
    props:['bus','attendanceData'],
    data: () => ({
        itemPerPage:0,
        englishName:'',
        date:'',
        time:'',
        menu:'',
        menu2:'',
        tutorName:'',
        actTaken:'',
        chkOther:'',
        chkOne:'',
        chkTwo:'',
        chkThere:'',
        tutor:'',
        tutors:[{'name':'','name2':''}],
        dueToUn:'',
        dueToMissed:'',
        NoMC:'',
        dueTo : ['Equipment failure','Power failure','Internet connection issue','Other'],
        position:'',
        posArr:['Tutor','Admin'],
        location:'',
        locArr:['Office','Home','Temporary Home'],
        chkUt:false,
        chkTar:false,
        inputRules: [
                v => v.length >= 1 || "Item is Required"
            ],
        NoAttempts:"",
        details:"",
        Tarhours:"",
        UThours:"",
        UtMissed:"",
        timestamp: new Date(),
        maxDate:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dialogshow: false,
        newDataStatus:'',

    }),
    computed: {
        post(){
            return {
                actionTaken:'insertdata',
                event:"attendanceIssue",
                tutor_id : this.tutor, 
                position: this.position,
                location:this.location,
                dateInfraction:this.date,
                actTaken:this.actTaken,
                unexcused:this.dueToUn,
                utHr:this.UThours,
                utMissed:this.UtMissed,
                tarHr:this.Tarhours,
                tarMissed:this.TarMissed,
                missedclass:this.dueToMissed,
                NoMC:this.NoMC,
                details:this.details,
                NoAttempts:this.NoAttempts,
                chkUt:this.chkUt,
                chkTar:this.chkTar,
                timestamp: this.timestamp.getFullYear()+"-"+(this.timestamp.getMonth() >= 9 ? (this.timestamp.getMonth()+1) : "0"+(this.timestamp.getMonth()+1))+"-"+(this.timestamp.getDate() > 9 ? this.timestamp.getDate() : "0"+this.timestamp.getDate())+" "+(this.timestamp.getHours() > 9 ? this.timestamp.getHours() : "0"+this.timestamp.getHours())+":"+(this.timestamp.getMinutes() > 9 ? this.timestamp.getMinutes() : "0"+this.timestamp.getMinutes())+":"+(this.timestamp.getSeconds() > 9 ? this.timestamp.getSeconds() : "0"+this.timestamp.getSeconds())
            }
        }
    },
    mounted(){
         axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        

              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_full_name
                    }

               }
               
              })

        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        

              for(let i = 0 ; i<=tutorlist.length ; i++){
                    this.tutors.push({
                            name:tutorlist[i].tutor_full_name,
                            name2:tutorlist[i].tutor_id
                    })

                     this.tutors.sort(function (a, b) {
                             return a.name2.localeCompare(b.name2);
                          });

               }
               
              })

             this.bus.$on('sendDataAttendance', this.sendDataAttendance)
             this.bus.$on('insertNewItem', this.insertNewItem)

    },
    methods:{
        
        SaveIssue(){

           if(this.$refs.form.validate()){
              
               axios.post('http://localhost/megatalking/performance/tutorperf.php',this.post).then(response=>{

                if(response.data == 'success' || response.data == 'successUpdate'){
                    return (this.dialogshow = true)
                   
                }
               }).catch(error=>console.log('this is the error '+error))

                if(this.newDataStatus == "update"){
                        this.$emit('updateRecord',this.post)
                }
                 
           } 
        },
        chooseActTaken(){

            this.dueToUn = "" 
            this.dueToMissed = ""
            this.Tarhours = ""
            this.UThours = ""
            this.TarMissed = ""
            this.UtMissed = ""
            this.NoMC = ""
            this.chkUt = false
            this.chkTar =  false

        },
        insertNewItem(){

          this.tutor = ""
          this.position = ""
          this.location = ""
          this.date= ""
          this.actTaken = ""
          this.dueToUn = ""
          this.UThours = ""
          this.UtMissed = ""
          this.Tarhours = ""
          this.TarMissed = ""
          this.dueToMissed = ""
          this.NoMC = ""
          this.details = ""
          this.NoAttempts = ""
          this.chkUt = ""
          this.chkTar = ""

        },
        sendDataAttendance(){
          let data = this.attendanceData

          this.tutor = data.tutor_id
          this.position = data.position
          this.location = data.location
          this.date= data.date
          this.actTaken = data.infraction
          this.dueToUn = data.unexcused
          this.UThours = data.utHr
          this.UtMissed = data.utMissed
          this.Tarhours = data.tarHr
          this.TarMissed = data.tarMissed
          this.dueToMissed = data.missedclass
          this.NoMC = data.NoMC
          this.details = data.details
          this.NoAttempts = data.NoAttempts
          this.chkUt = data.chkUt
          this.chkTar = data.chkTar
          this.newDataStatus = data.status

        }

   }
}
</script>
<style scoped>
#form{
    background-color: rgb(246, 246, 246);
}
.font-11
{
    font-size:11px
}
.font-14{
    font-size:14px
}
.font-9
{
    font-size:9px
}
.input-size{
    max-width: 130px !important;
}
.input-size-other{
    max-width: 300px !important;
    
}
.input-size-missed{
    max-width: 200px !important;
    margin-left:100px !important;
}
.attemp-field{
    max-width: 200px !important;
}
.styled-input label[for] {
  height: 40px;
  font-size: 9px !important;
}

.barcolor{
    background-color: rgb(229, 229, 229);
    padding: 20px !important;
    font-weight: bold;
    width:100% !important;
}
.barcolor2{
    background-color: rgb(229, 229, 229);
    font-weight: bold;
    width:100% !important;
}
.textareaBg{
    background-color: white !important;
}
.textarea{
    width:500px !important;
    font-size:10px;
}
.chkbox{
    width:20px;
}
.chkboxLabel{
    font-size:14px;
}
.tutor-field{
    width:340px;
}
.infactor-sub-menu{
    font-size:12px;
}
</style>